import { useEffect } from 'react';
import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { fetchMtrDetail } from '#/api/imsMgmt/settings/mtr/fetchDetail';
import { ROUTES } from '#/config/routes';
import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import MtrBlock from '#/modules/imsMgmt/settings/mtr/components/MtrBlock';
import MtrSnMappingsCard from '#/modules/imsMgmt/settings/mtr/components/MtrSnMappingsCard';
import { getMtrApiErrorMessage } from '#/modules/imsMgmt/settings/mtr/helper/apiError';
import PageShell from '#/modules/infra/layout/PageShell';
import { mtrDetailQueryKey } from '#/utils/queryKeys';
import { toast } from '#/utils/toast';

const MtrDetailPage = () => {
  const { id } = useParams();

  const detailQuery = useQuery({
    queryKey: mtrDetailQueryKey(id),
    queryFn: () => fetchMtrDetail(id),
    enabled: Boolean(id),
  });

  useEffect(() => {
    if (!detailQuery.isError) {
      return;
    }
    toast.error(getMtrApiErrorMessage(detailQuery.error, '載入物料失敗'));
  }, [detailQuery.isError, detailQuery.error]);

  const detail = detailQuery.data?.data;
  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div
            className={cn(
              'sticky top-0 z-20 -mx-1 flex flex-wrap items-center gap-2',
              'border-b border-slate-200 bg-canvas px-1 pb-3 pt-1',
            )}
          >
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">物料詳情</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.mtr}>返回列表</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getMtrApiErrorMessage(detailQuery.error, '載入物料失敗')}
            </p>
          ) : null}

          {detail ? (
            <>
              <MtrBlock
                detail={detail}
                showActions
                onRefetch={() => detailQuery.refetch()}
              />
              <MtrSnMappingsCard
                mtrId={detail.id}
                detailUpdatedAt={detail.record?.updatedAt ?? detail.updatedAt ?? null}
                onDetailRefetch={() => detailQuery.refetch()}
              />
            </>
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default MtrDetailPage;
